/**
 * @generated SignedSource<<d562a6eeee80bf0603b2b8886ca55a14>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeactivatedQuotes_preCheckoutTransaction$data = {
  readonly serviceId: string | null;
  readonly shipmentQuotes: ReadonlyArray<{
    readonly hasBeenAcceptedByDealer: boolean | null;
    readonly isLocalPickup: boolean | null;
    readonly isPreQuote: boolean | null;
    readonly serviceId: string | null;
    readonly serviceMethod: {
      readonly serviceMethodType: string | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"DeactivatedQuoteExplanation_shipmentQuote" | "PreQuoteTitle_shipmentQuote">;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"PreQuoteTitle_transaction">;
  readonly " $fragmentType": "DeactivatedQuotes_preCheckoutTransaction";
};
export type DeactivatedQuotes_preCheckoutTransaction$key = {
  readonly " $data"?: DeactivatedQuotes_preCheckoutTransaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"DeactivatedQuotes_preCheckoutTransaction">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DeactivatedQuotes_preCheckoutTransaction",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PreQuoteTitle_transaction"
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ShipmentQuote",
      "kind": "LinkedField",
      "name": "shipmentQuotes",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PreQuoteTitle_shipmentQuote"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "DeactivatedQuoteExplanation_shipmentQuote"
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isLocalPickup",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasBeenAcceptedByDealer",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ShipmentServiceMethod",
          "kind": "LinkedField",
          "name": "serviceMethod",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceMethodType",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isPreQuote",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};
})();

(node as any).hash = "a0cb5064a8bfffda39b2e33c94b3ddaa";

export default node;
